import "./onesignal.js";

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";

import "./styles/main.scss";
import App from "./components/App";

import packageJson from "../package.json";

import axios from "axios";

if (process.env.NODE_ENV === "development") {
    axios.defaults.baseURL = process.env.REACT_APP_APP_URL;
}

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

axios.get(`/sanctum/csrf-cookie`);

console.log(`App version ${packageJson.version}`);

document.querySelector("html").setAttribute("version", packageJson.version);

ReactDOM.render(<App />, document.getElementById("root"));
